// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-Dashboard-__reviews-box__container--1c971","table":"src-components-Dashboard-__reviews-box__table--3ubgu","headsUp":"src-components-Dashboard-__reviews-box__headsUp--2CIWh","row":"src-components-Dashboard-__reviews-box__row--1BWv8","cell":"src-components-Dashboard-__reviews-box__cell--2K7Jl","sectionHeading":"src-components-Dashboard-__reviews-box__sectionHeading--3Cyyy","name":"src-components-Dashboard-__reviews-box__name--2lwDt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Dashboard/reviews-box.css
// module id = 771
// module chunks = 0